import { Injectable } from '@angular/core';
import { APP_CONFIG } from '../../environment';
import { IDocumentFieldsRequest } from '../../model/models/document-verification/document-fields-request.interface';
import { IUpdateDocumentRequestEntity } from '../../model/api/document-verification/update-document-request.entity.interface';
import { IDocumentSpecificDetailsResponseEntity } from '../../model/api/document-verification/document-specific-details-response.entity.interface';
import { FormControlMapper } from '../formbuilder/formcontrol-mapper';
import { HttpProvider } from '../http/http';

@Injectable()
export class DocumentVerificationProvider {
  constructor(private httpProvider: HttpProvider) { }

  submitFields(request: IUpdateDocumentRequestEntity): Promise<string> {

    // Sometimes this field id comes back differently, need to check/map here if so and documentNumber is empty.
    if (!request.documentNumber && request['identificationNumber']) {
      request.documentNumber = request['identificationNumber'];
      delete request['identificationNumber'];
    }
    
    return this.httpProvider
      .post(`${APP_CONFIG.remittanceApiBaseUrl}identification/details`, request);
  }

  // Why is this a POST and not a GET? Not sure..
  getSpecificDetails(request: IDocumentFieldsRequest): Promise<IDocumentSpecificDetailsResponseEntity> {
    return this.httpProvider
      .post(`${APP_CONFIG.remittanceApiBaseUrl}identification/specificdetails`, request, (res: IDocumentSpecificDetailsResponseEntity) => {
        // We want to map form fields
        return {...res, fields: FormControlMapper.fromFormResponse(res)}
      });
  }

}



// WEBPACK FOOTER //
// ./src/providers/document-verification/document-verification.ts